import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="bg-white min-h-screen">
        <section className="py-20 px-8 md:px-[140px] bg-gradient-to-b from-[#8e0707] to-[#6b0505]">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h1 className="text-4xl md:text-6xl font-medium text-white mb-6">
                Preserving the taste of care, one jar at a time.
              </h1>
              <p className="text-xl text-white/80">
                Sunkissed was born in our home kitchen, inspired by my mother's timeless recipes. Each jar carries the warmth of her hands, the patience of slow sun-drying, and the comfort of home. What began as a terrace ritual — fruits, spices, and love basking under the sun — is now a way to share that sunshine with every home.
              </p>
               <div className="max-w-6xl mx-auto flex justify-left gap-4 mt-8">
            <Link to="/products">
              <button className="bg-white text-[#8e0707] px-8 py-3 text-lg rounded hover:bg-gray-100">
                Shop now
              </button>
            </Link>
            <Link to="/partner">
              <button className="bg-transparent border-2 border-white text-white px-8 py-3 text-lg rounded hover:bg-white/10">
                Be a partner →
              </button>
            </Link>
          </div>
            </div>
            <div className="flex-shrink-0">
              <img 
                src="/Aboutmain.png" 
                alt="About Sunkissed Pickles" 
                className="w-[376px] h-[526px] object-cover rounded-lg"
              />
            </div>
          </div>
         
        </section>

        <section className="py-16 px-8 md:px-[140px]">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-[#272727] mb-8">About Sunkissed Pickles</h2>
            <p className="text-lg text-[#272727]/80 mb-6 leading-relaxed">
              Sunkissed Homemade Pickles brings you the authentic taste of traditional Indian pickles, 
              crafted with love and care using time-honored family recipes passed down through generations.
            </p>
            <p className="text-lg text-[#272727]/80 mb-6 leading-relaxed">
              Our journey began in a small kitchen where grandma's recipes met modern hygiene standards. 
              We believe that the best pickles are made with the freshest ingredients, pure mustard oil, 
              and a whole lot of patience.
            </p>
            <p className="text-lg text-[#272727]/80 mb-6 leading-relaxed">
              Each jar of Sunkissed pickle is a testament to our commitment to quality. We source our 
              mangoes, lemons, and chilies from local farmers, ensuring that every bite transports you 
              to the warmth of a traditional Indian home.
            </p>
          </div>
        </section>

        <section className="py-16 px-8 md:px-[140px] bg-[#f8f8f8]">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-[#272727] mb-12 text-center">Our Values</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-[#8e0707] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🏠</span>
                </div>
                <h3 className="text-xl font-bold text-[#272727] mb-2">Homemade</h3>
                <p className="text-[#272727]/70">Made with traditional recipes in small batches</p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-[#8e0707] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🌿</span>
                </div>
                <h3 className="text-xl font-bold text-[#272727] mb-2">Natural</h3>
                <p className="text-[#272727]/70">No preservatives, only natural ingredients</p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-[#8e0707] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">❤️</span>
                </div>
                <h3 className="text-xl font-bold text-[#272727] mb-2">Love</h3>
                <p className="text-[#272727]/70">Crafted with love and care for you</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 px-8 md:px-[140px]">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-[#272727] mb-6">Ready to taste the difference?</h2>
            <Link to="/products">
              <button className="bg-[#8e0707] hover:bg-[#6b0505] text-white px-8 py-3 text-lg rounded">
                Shop Now
              </button>
            </Link>
          </div>
        </section>
    </div>
  );
};

export default AboutPage;
